import React from "react";
import { includes, xor } from "lodash";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import {
  FilterButtonList,
  FilterDropdownContent,
} from "@sonder/ui/source/styled/fragments/GenericFilters";
import { setFilters } from "checkouts/actions";
import { CheckoutStatusFilterGroupItem } from "checkouts/components/Filters/CheckoutStatusFilterGroupItem";
import { useStore as useCheckoutsStore } from "checkouts/store";
import { InquiryCheckoutStatus } from "typings/globalGQLTypes";

export const CheckoutStatusFilters = () => {
  const {
    state: {
      filters: { checkoutStatuses },
    },
    dispatch,
  } = useCheckoutsStore();
  const filteredStatuses = Object.values(InquiryCheckoutStatus);
  const totalSelected = checkoutStatuses.length || 0;

  const onClickOption = (status: InquiryCheckoutStatus) => {
    const newStatuses = xor(checkoutStatuses, [status]);
    dispatch(setFilters({ checkoutStatuses: newStatuses }));
  };

  const renderStatus = (status: InquiryCheckoutStatus) => {
    const isChecked = includes(checkoutStatuses, status);
    return (
      <CheckoutStatusFilterGroupItem
        checkoutStatus={status}
        isChecked={isChecked}
        key={status}
        onClick={() => onClickOption(status)}
      />
    );
  };

  return (
    <Dropdown
      trigger={
        <Button fullWidth iconRight type="button">
          Checkout Status
          {totalSelected > 0 && ` (${totalSelected})`}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen: isPortalOpen }) =>
        isPortalOpen && (
          <FilterDropdownContent align="left">
            <FilterButtonList>
              {filteredStatuses.map(renderStatus)}
            </FilterButtonList>
          </FilterDropdownContent>
        )
      }
    </Dropdown>
  );
};
